import gql from 'graphql-tag';

const DELETE_LEAD_APPOINTMENT = gql` 
  mutation deleteLeadAppointment($input: LeadAppointmentDeleteInput!, $sendEmail: Boolean!) {
    deleteLeadAppointment(input: $input, sendEmail: $sendEmail) {
      message
      code
    }
  }
`;

export default DELETE_LEAD_APPOINTMENT;
